import { Component, OnInit, ViewEncapsulation } from "@angular/core";
@Component({
    selector: 'app-save-json-popup',
    templateUrl: "./save-json-popup.component.html",
    styleUrls: ["./save-json-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SaveJsonPopupComponent implements OnInit {
    fileName: string = "Cannabistherapie-Kostenübernahmeantrag";
    secretType: string = "encrypted";
    secretKey: string = "";

    constructor() {
    }

    ngOnInit(): void {
    }

}
